import { PhraseHighlight } from '@/components/displays/PhraseHighlight';
import { ResultDisplayCard } from '@/components/results/ResultDisplayCard';
import { ResultDisplayRecording } from '@/components/results/ResultDisplayRecording';
import { ResultDisplayWriting } from '@/components/results/ResultDisplayWriting';
import { RESULT_DISPLAY_SIZE } from '@/constant';
import { isSlideComponentCharacter } from '@/types/slide';
import AssignmentLateIcon from '@mui/icons-material/AssignmentLate';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import { Box, Skeleton } from '@mui/material';
import { useEffect, useState } from 'react';
import { ResultContentProps } from '../../ExportableResultSlide';
import { ResultContentContainer } from './ResultContentContainer';

export const ResultContentCharacter: React.FC<ResultContentProps & { viewOnly: boolean }> = ({ question, viewOnly, onLoad }) => {
    const [loading, setLoading] = useState<boolean | undefined>(question.answers[0]?.fetchResultFiles ? true : false);
    const [resultFiles, setResultFiles] = useState<{ url: string }[] | undefined>(undefined);

    const answer = question.answers[0];
    useEffect(() => {
        if (answer?.gameType === 'Audio' && answer?.fetchResultFiles) {
            setLoading(true);
            answer
                .fetchResultFiles()
                .then((files) => {
                    setResultFiles(files);
                })
                .finally(() => {
                    setLoading(false);
                });
        } else {
            setResultFiles(undefined);
        }
    }, [answer, question]);

    if (!isSlideComponentCharacter(question)) {
        return <></>;
    }

    const audioResultFile = question.content.gameType === 'Audio' ? resultFiles?.[0] : undefined;

    return (
        <ResultContentContainer>
            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 2, position: 'relative' }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <Box
                        component='img'
                        src={
                            question.content.imageURL && question.content.imageURL !== ''
                                ? question.content.imageURL
                                : `/asset/characters/${question.content.image ? question.content.image + '/image.png' : 'default.png'}`
                        }
                        sx={{ width: 200, height: 200, objectFit: 'contain' }}
                        onLoad={onLoad}
                    />
                    <PhraseHighlight sx={{ color: '#555' }} phrase={question.content.phrase} highlight={question.content.characterList[question.content.character]?.character} />
                </Box>

                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <DoubleArrowIcon sx={{ fontSize: 48 }} />
                </Box>
                {question.content.gameType === 'Writing' ? (
                    <Box sx={{ width: RESULT_DISPLAY_SIZE.width, height: RESULT_DISPLAY_SIZE.height }}>
                        <ResultDisplayWriting type='question' question={question} viewOnly={viewOnly} />
                    </Box>
                ) : question.content.gameType === 'OneCard' || question.content.gameType === 'TwoCards' ? (
                    <ResultDisplayCard question={question} />
                ) : question.content.gameType === 'Audio' ? (
                    loading ? (
                        <Skeleton variant='rounded' sx={{ width: RESULT_DISPLAY_SIZE.width, height: RESULT_DISPLAY_SIZE.height }} />
                    ) : (
                        <ResultDisplayRecording src={audioResultFile?.url} />
                    )
                ) : (
                    <Box sx={{ width: 200, height: 200, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <AssignmentLateIcon sx={{ width: 160, height: 160 }} />
                    </Box>
                )}
            </Box>
        </ResultContentContainer>
    );
};
